import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { setIntlRef } from '@/lib/intl';

const IntlBridge = () => {
  const intl = useIntl();

  useEffect(() => {
    setIntlRef(intl);
  }, [intl]);

  return null;
};

export default IntlBridge;
